/**
 * Centralized Application Configuration
 *
 * Contains shared constants and configuration values used across the application.
 * This prevents duplicate definitions and makes maintenance easier.
 */

// Event/Location Information
// Placeholder copy for the yacht event. Dates mimic the mmyt-dev signup page;
// the multi-city itinerary is a placeholder until the full schedule firms up.
export const EVENT_INFO = {
  dates: "June 17th – 29th, 2026",
  openingDays: "",
  hours: "",
  location: "St. Tropez · Monaco",
  address: "",
  locationShort: "French Riviera",
  imageAlt: "Maison Mytheresa Yacht 2026",
};

// Privacy Policy URLs
export const PRIVACY_URLS = {
  policyUrl: "https://www.mytheresa.com/ch/en/privacy-policy",
  servicePolicyUrl: "https://www.mytheresa.com/to/service/privacy-policy/",
  // Passport T&C link (customer-supplied de/en URL).
  passportPolicyUrl: "https://www.mytheresa.com/de/en/privacy-policy?rdr=mt",
};

// Data controller named in the passport T&C as the recipient that deletes the
// scans after verification.
export const COMPANY_NAME = "M/Y Alulim";

// Disclaimer Text Templates
export const DISCLAIMERS = {
  marketing: `I agree to receive the Mytheresa newsletter featuring updates on emails from LuxExperience B.V. I consent to the use of analytical web beacons within the newsletter and the creation of a personalized user profile based on my purchasing and browsing behavior. This may include notifications when I place items in my shopping cart. For more information, please refer to clause 5 of our {privacyPolicyLink}. I can withdraw my consent at any time by using the unsubscribe link included in every newsletter or by emailing privacy@mytheresa.com.`,
  privacyPolicyText: "Privacy Policy",
  // Shown above the (optional) passport upload control.
  passportUpload: "Please be prepared to present passport details when boarding the yacht for this event. You are welcome to upload a photo of your passport in advance, here:",
  // Revealed from the (?) tooltip next to the upload disclaimer.
  passportTnc: `We process personal data for the purpose of organizing and conducting the event. Passenger passport scans are requested solely to comply with applicable European maritime, safety, insurance, and regulatory obligations (e.g. maintaining an accurate guest list for emergency response and authority controls). All personal data will be processed in accordance with the GDPR, used exclusively for this purpose, and securely deleted immediately after verification by the recipient, ${COMPANY_NAME}. For the technical operation of the event, personal data will be transferred to ThinAir as our data processor pursuant to Art. 28 GDPR. ThinAir processes such data solely on our behalf and stores it only for the duration necessary to provide the service, and in any event no longer than 24 hours after the end of the event. Further information on the processing of personal data can be found in our {privacyPolicyLink}.`,
};

// Email Providers for autocomplete suggestions
export const EMAIL_PROVIDERS = [
  "@gmail.com",
  "@yahoo.com",
  "@outlook.com",
  "@hotmail.com",
  "@icloud.com",
  "@aol.com",
  "@protonmail.com",
  "@mail.com",
  "@gmx.com",
  "@zoho.com",
  "@yandex.com",
];

// Restricted Email Domains (when REACT_APP_RESTRICT_EMAIL_DOMAINS is true)
export const RESTRICTED_EMAIL_DOMAINS = [
  "@mytheresa.com",
  "@gmail.com",
];

// Form Validation Patterns
export const VALIDATION_PATTERNS = {
  name: /^[A-Za-zÀ-ÿ\s'-]+$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phone: /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/,
};

// Form Validation Messages
export const VALIDATION_MESSAGES = {
  required: "This field is required",
  nameInvalid: "Only letters, spaces, hyphens and apostrophes are allowed",
  emailInvalid: "Please enter a valid email address",
  emailRestricted: "Please use your company email address",
  phoneInvalid: "Please enter a valid phone number",
};

// Cookie Consent Configuration
export const COOKIE_CONFIG = {
  storageName: "myt_cookie_consent",
  cookieNotice: "We use cookies for analytics. Click 'OK' to continue browsing.",
  acceptText: "OK",
  learnMoreText: "Learn more",
};
